import { RequestOptions } from './types';

export class API {
  private constructor() { }

  static async post(route: string, body: any, options?: RequestOptions): Promise<Response> {
    const response = await fetch(route, {
      method: 'POST',
      headers: {
        'Accept': 'application/json',
        'Content-Type': 'application/json',
        ...options?.headers
      },
      body: JSON.stringify(body)
    });

    return response;
  }

  static async patch(route: string, body: any, options?: RequestOptions): Promise<Response> {
    const headers = new Headers(options?.headers);
    headers.set('Accept', 'application/json');
    headers.set('Content-Type', 'application/json');

    const response = await fetch(route, {
      method: 'PATCH',
      headers: Object.fromEntries(headers.entries()),
      body: JSON.stringify(body)
    });

    return response;
  }

  static async validateResponseJSON<T>(response: Response, guard: (x: unknown) => x is T): Promise<T | null> {
    const responseJson: unknown = await response.json();

    if (guard(responseJson)) {
      return responseJson;
    } else {
      return null;
    }
  }
}
